import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { QuestionCard } from './QuestionCard';
import { TestConfigModal } from './TestConfigModal';
import { useFilter } from '../contexts/FilterContext';
import { BookOpenIcon, ChevronRightIcon, ArrowLeftIcon } from './icons/InterfaceIcons';

const papersData = [
  {    "shift": "JEE Main 2002",    "occurrences": 190  },
  {    "shift": "JEE Main 2003",    "occurrences": 191  },
  {    "shift": "JEE Main 2004",    "occurrences": 197  },
  {    "shift": "JEE Main 2005",    "occurrences": 186  },
  {    "shift": "JEE Main 2006",    "occurrences": 137  },
  {    "shift": "JEE Main 2007",    "occurrences": 100  },
  {    "shift": "JEE Main 2008",    "occurrences": 88  },
  {    "shift": "JEE Main 2009",    "occurrences": 77  },
  {    "shift": "JEE Main 2010",    "occurrences": 80  },
  {    "shift": "JEE Main 2011",    "occurrences": 77  },
  {    "shift": "JEE Main 2012 (07 May Online)",    "occurrences": 73  },
  {    "shift": "JEE Main 2012 (12 May Online)",    "occurrences": 74  },
  {    "shift": "JEE Main 2012 (19 May Online)",    "occurrences": 73  },
  {    "shift": "JEE Main 2012 (26 May Online)",    "occurrences": 71  },
  {    "shift": "JEE Main 2012 (Offline)",    "occurrences": 72  },
  {    "shift": "JEE Main 2013 (07 Apr)",    "occurrences": 75  },
  {    "shift": "JEE Main 2013 (09 Apr Online)",    "occurrences": 77  },
  {    "shift": "JEE Main 2013 (22 Apr Online)",    "occurrences": 77  },
  {    "shift": "JEE Main 2013 (23 Apr Online)",    "occurrences": 71  },
  {    "shift": "JEE Main 2013 (25 Apr Online)",    "occurrences": 74  },
  {    "shift": "JEE Main 2014 (06 Apr)",    "occurrences": 74  },
  {    "shift": "JEE Main 2014 (09 Apr Online)",    "occurrences": 73  },
  {    "shift": "JEE Main 2014 (11 Apr Online)",    "occurrences": 72  },
  {    "shift": "JEE Main 2014 (12 Apr Online)",    "occurrences": 74  },
  {    "shift": "JEE Main 2014 (19 Apr Online)",    "occurrences": 75  },
  {    "shift": "JEE Main 2015 (04 Apr)",    "occurrences": 70  },
  {    "shift": "JEE Main 2015 (10 Apr Online)",    "occurrences": 74  },
  {    "shift": "JEE Main 2015 (11 Apr Online)",    "occurrences": 73  },
  {    "shift": "JEE Main 2016 (03 Apr)",    "occurrences": 65  },
  {    "shift": "JEE Main 2016 (09 Apr Online)",    "occurrences": 69  },
  {    "shift": "JEE Main 2016 (10 Apr Online)",    "occurrences": 69  },
  {    "shift": "JEE Main 2017 (02 Apr)",    "occurrences": 73  },
  {    "shift": "JEE Main 2017 (08 Apr Online)",    "occurrences": 73  },
  {    "shift": "JEE Main 2017 (09 Apr Online)",    "occurrences": 78  },
  {    "shift": "JEE Main 2018 (08 Apr)",    "occurrences": 73  },
  {    "shift": "JEE Main 2018 (15 Apr)",    "occurrences": 76  },
  {    "shift": "JEE Main 2018 (15 Apr Shift 1 Online)",    "occurrences": 73  },
  {    "shift": "JEE Main 2018 (15 Apr Shift 2 Online)",    "occurrences": 74  },
  {    "shift": "JEE Main 2018 (16 Apr Online)",    "occurrences": 79  },
  {    "shift": "JEE Main 2019 (08 Apr Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2019 (08 Apr Shift 2)",    "occurrences": 71  },
  {    "shift": "JEE Main 2019 (09 Apr Shift 1)",    "occurrences": 76  },
  {    "shift": "JEE Main 2019 (09 Apr Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2019 (09 Jan Shift 1)",    "occurrences": 72  },
  {    "shift": "JEE Main 2019 (09 Jan Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2019 (10 Apr Shift 1)",    "occurrences": 70  },
  {    "shift": "JEE Main 2019 (10 Apr Shift 2)",    "occurrences": 69  },
  {    "shift": "JEE Main 2019 (10 Jan Shift 1)",    "occurrences": 67  },
  {    "shift": "JEE Main 2019 (10 Jan Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2019 (11 Jan Shift 1)",    "occurrences": 70  },
  {    "shift": "JEE Main 2019 (11 Jan Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2019 (12 Apr Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2019 (12 Apr Shift 2)",    "occurrences": 69  },
  {    "shift": "JEE Main 2019 (12 Jan Shift 1)",    "occurrences": 76  },
  {    "shift": "JEE Main 2019 (12 Jan Shift 2)",    "occurrences": 71  },
  {    "shift": "JEE Main 2020 (02 Sep Shift 1)",    "occurrences": 62  },
  {    "shift": "JEE Main 2020 (02 Sep Shift 2)",    "occurrences": 62  },
  {    "shift": "JEE Main 2020 (03 Sep Shift 1)",    "occurrences": 62  },
  {    "shift": "JEE Main 2020 (03 Sep Shift 2)",    "occurrences": 63  },
  {    "shift": "JEE Main 2020 (04 Sep Shift 1)",    "occurrences": 64  },
  {    "shift": "JEE Main 2020 (04 Sep Shift 2)",    "occurrences": 63  },
  {    "shift": "JEE Main 2020 (05 Sep Shift 1)",    "occurrences": 62  },
  {    "shift": "JEE Main 2020 (05 Sep Shift 2)",    "occurrences": 58  },
  {    "shift": "JEE Main 2020 (06 Sep Shift 1)",    "occurrences": 63  },
  {    "shift": "JEE Main 2020 (06 Sep Shift 2)",    "occurrences": 58  },
  {    "shift": "JEE Main 2020 (07 Jan Shift 1)",    "occurrences": 63  },
  {    "shift": "JEE Main 2020 (07 Jan Shift 2)",    "occurrences": 59  },
  {    "shift": "JEE Main 2020 (08 Jan Shift 1)",    "occurrences": 62  },
  {    "shift": "JEE Main 2020 (08 Jan Shift 2)",    "occurrences": 60  },
  {    "shift": "JEE Main 2020 (09 Jan Shift 1)",    "occurrences": 66  },
  {    "shift": "JEE Main 2020 (09 Jan Shift 2)",    "occurrences": 63  },
  {    "shift": "JEE Main 2021 (01 Sep Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2021 (16 Mar Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2021 (16 Mar Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2021 (17 Mar Shift 1)",    "occurrences": 77  },
  {    "shift": "JEE Main 2021 (17 Mar Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2021 (18 Mar Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2021 (18 Mar Shift 2)",    "occurrences": 69  },
  {    "shift": "JEE Main 2021 (20 Jul Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2021 (20 Jul Shift 2)",    "occurrences": 71  },
  {    "shift": "JEE Main 2021 (22 Jul Shift 1)",    "occurrences": 76  },
  {    "shift": "JEE Main 2021 (24 Feb Shift 1)",    "occurrences": 71  },
  {    "shift": "JEE Main 2021 (24 Feb Shift 2)",    "occurrences": 67  },
  {    "shift": "JEE Main 2021 (25 Feb Shift 1)",    "occurrences": 72  },
  {    "shift": "JEE Main 2021 (25 Feb Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2021 (25 Jul Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2021 (25 Jul Shift 2)",    "occurrences": 71  },
  {    "shift": "JEE Main 2021 (26 Aug Shift 1)",    "occurrences": 68  },
  {    "shift": "JEE Main 2021 (26 Aug Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2021 (26 Feb Shift 1)",    "occurrences": 70  },
  {    "shift": "JEE Main 2021 (26 Feb Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2021 (27 Aug Shift 1)",    "occurrences": 69  },
  {    "shift": "JEE Main 2021 (27 Aug Shift 2)",    "occurrences": 67  },
  {    "shift": "JEE Main 2021 (27 Jul Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2021 (27 Jul Shift 2)",    "occurrences": 75  },
  {    "shift": "JEE Main 2021 (31 Aug Shift 1)",    "occurrences": 72  },
  {    "shift": "JEE Main 2021 (31 Aug Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2022 (24 Jun Shift 1)",    "occurrences": 71  },
  {    "shift": "JEE Main 2022 (24 Jun Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2022 (25 Jul Shift 1)",    "occurrences": 75  },
  {    "shift": "JEE Main 2022 (25 Jul Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2022 (25 Jun Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2022 (25 Jun Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2022 (26 Jul Shift 1)",    "occurrences": 75  },
  {    "shift": "JEE Main 2022 (26 Jul Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2022 (26 Jun Shift 1)",    "occurrences": 72  },
  {    "shift": "JEE Main 2022 (26 Jun Shift 2)",    "occurrences": 70  },
  {    "shift": "JEE Main 2022 (27 Jul Shift 1)",    "occurrences": 72  },
  {    "shift": "JEE Main 2022 (27 Jul Shift 2)",    "occurrences": 69  },
  {    "shift": "JEE Main 2022 (27 Jun Shift 1)",    "occurrences": 71  },
  {    "shift": "JEE Main 2022 (27 Jun Shift 2)",    "occurrences": 78  },
  {    "shift": "JEE Main 2022 (28 Jul Shift 1)",    "occurrences": 71  },
  {    "shift": "JEE Main 2022 (28 Jul Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2022 (28 Jun Shift 1)",    "occurrences": 72  },
  {    "shift": "JEE Main 2022 (28 Jun Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2022 (29 Jul Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2022 (29 Jul Shift 2)",    "occurrences": 71  },
  {    "shift": "JEE Main 2022 (29 Jun Shift 1)",    "occurrences": 69  },
  {    "shift": "JEE Main 2022 (29 Jun Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2023 (01 Feb Shift 1)",    "occurrences": 70  },
  {    "shift": "JEE Main 2023 (01 Feb Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2023 (06 Apr Shift 1)",    "occurrences": 76  },
  {    "shift": "JEE Main 2023 (06 Apr Shift 2)",    "occurrences": 77  },
  {    "shift": "JEE Main 2023 (08 Apr Shift 1)",    "occurrences": 75  },
  {    "shift": "JEE Main 2023 (08 Apr Shift 2)",    "occurrences": 68  },
  {    "shift": "JEE Main 2023 (10 Apr Shift 1)",    "occurrences": 76  },
  {    "shift": "JEE Main 2023 (10 Apr Shift 2)",    "occurrences": 71  },
  {    "shift": "JEE Main 2023 (11 Apr Shift 1)",    "occurrences": 78  },
  {    "shift": "JEE Main 2023 (11 Apr Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2023 (12 Apr Shift 1)",    "occurrences": 69  },
  {    "shift": "JEE Main 2023 (13 Apr Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2023 (13 Apr Shift 2)",    "occurrences": 76  },
  {    "shift": "JEE Main 2023 (15 Apr Shift 1)",    "occurrences": 76  },
  {    "shift": "JEE Main 2023 (24 Jan Shift 1)",    "occurrences": 71  },
  {    "shift": "JEE Main 2023 (24 Jan Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2023 (25 Jan Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2023 (25 Jan Shift 2)",    "occurrences": 76  },
  {    "shift": "JEE Main 2023 (29 Jan Shift 1)",    "occurrences": 70  },
  {    "shift": "JEE Main 2023 (29 Jan Shift 2)",    "occurrences": 70  },
  {    "shift": "JEE Main 2023 (30 Jan Shift 1)",    "occurrences": 72  },
  {    "shift": "JEE Main 2023 (30 Jan Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2023 (31 Jan Shift 1)",    "occurrences": 77  },
  {    "shift": "JEE Main 2023 (31 Jan Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2024 (01 Feb Shift 1)",    "occurrences": 89  },
  {    "shift": "JEE Main 2024 (01 Feb Shift 2)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (04 Apr Shift 1)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (04 Apr Shift 2)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (05 Apr Shift 1)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (05 Apr Shift 2)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (06 Apr Shift 1)",    "occurrences": 89  },
  {    "shift": "JEE Main 2024 (06 Apr Shift 2)",    "occurrences": 87  },
  {    "shift": "JEE Main 2024 (08 Apr Shift 1)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (08 Apr Shift 2)",    "occurrences": 89  },
  {    "shift": "JEE Main 2024 (09 Apr Shift 1)",    "occurrences": 89  },
  {    "shift": "JEE Main 2024 (09 Apr Shift 2)",    "occurrences": 89  },
  {    "shift": "JEE Main 2024 (27 Jan Shift 1)",    "occurrences": 87  },
  {    "shift": "JEE Main 2024 (27 Jan Shift 2)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (29 Jan Shift 1)",    "occurrences": 86  },
  {    "shift": "JEE Main 2024 (29 Jan Shift 2)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (30 Jan Shift 1)",    "occurrences": 86  },
  {    "shift": "JEE Main 2024 (30 Jan Shift 2)",    "occurrences": 88  },
  {    "shift": "JEE Main 2024 (31 Jan Shift 1)",    "occurrences": 89  },
  {    "shift": "JEE Main 2024 (31 Jan Shift 2)",    "occurrences": 87  },
  {    "shift": "JEE Main 2025 (22 Jan Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (22 Jan Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (23 Jan Shift 1)",    "occurrences": 75  },
  {    "shift": "JEE Main 2025 (23 Jan Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (24 Jan Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (24 Jan Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2025 (28 Jan Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (28 Jan Shift 2)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (29 Jan Shift 1)",    "occurrences": 75  },
  {    "shift": "JEE Main 2025 (29 Jan Shift 2)",    "occurrences": 75  },
  {    "shift": "JEE Main 2025 (2 Apr Shift 1)",    "occurrences": 73  },
  {    "shift": "JEE Main 2025 (2 Apr Shift 2)",    "occurrences": 75  },
  {    "shift": "JEE Main 2025 (3 Apr Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (3 Apr Shift 2)",    "occurrences": 72  },
  {    "shift": "JEE Main 2025 (4 Apr Shift 1)",    "occurrences": 74  },
  {    "shift": "JEE Main 2025 (4 Apr Shift 2)",    "occurrences": 73  },
  {    "shift": "JEE Main 2025 (7 Apr Shift 1)",    "occurrences": 75  },
  {    "shift": "JEE Main 2025 (7 Apr Shift 2)",    "occurrences": 75  },
  {    "shift": "JEE Main 2025 (8 Apr Shift 2)",    "occurrences": 74  }
  // ... (rest of papersData)
];

const PAGE_SIZE = 10;

const getDifficultyFromLevel = (level) => {
    switch (level) {
        case 1: return 'Easy';
        case 2: return 'Medium';
        case 3: return 'Hard';
        default: return 'Medium';
    }
};

const PaperCard: React.FC<{ paper: { shift: string; occurrences: number; }, onClick: () => void, onAttempt: () => void }> = ({ paper, onClick, onAttempt }) => (
    <div className="bg-brand-surface border border-brand-border rounded-lg p-4 hover:bg-brand-primary/5 hover:border-brand-primary transition-all duration-200 group">
        <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-4 cursor-pointer" onClick={onClick}>
                <BookOpenIcon className="w-5 h-5 text-brand-text-secondary group-hover:text-brand-primary transition-colors" />
                <div>
                    <h3 className="font-semibold text-brand-text-primary">{paper.shift}</h3>
                    <p className="text-sm text-brand-text-secondary">{paper.occurrences} Questions</p>
                </div>
            </div>
            <ChevronRightIcon className="w-5 h-5 text-brand-text-secondary group-hover:text-brand-primary transition-colors cursor-pointer" onClick={onClick} />
        </div>
        <button
            onClick={onAttempt}
            className="w-full px-4 py-2 bg-brand-primary text-white rounded-lg hover:bg-brand-primary-hover transition-colors font-medium"
        >
            Attempt
        </button>
    </div>
);

export const JEEMainPaperWiseView = ({ user, onToggleBookmark, onNavigateToSignIn }) => {
    const navigate = useNavigate();
    const [selectedPaper, setSelectedPaper] = useState<string | null>(null);
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [activeDifficulty, setActiveDifficulty] = useState('All');
    const [activeSubject, setActiveSubject] = useState('All');
    const [activeChapter, setActiveChapter] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [showTestConfig, setShowTestConfig] = useState(false);
    const [selectedPaperForTest, setSelectedPaperForTest] = useState(null);
    const { setShowFilter, setFilterData } = useFilter();

     useEffect(() => {
        if (!selectedPaper) {
            setQuestions([]);
            return;
        }

        const fetchQuestions = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const { data, error: dbError } = await supabase
                    .from('jeemain')
                    .select('*')
                    .eq('shift', selectedPaper);

                if (dbError) throw dbError;

                if (data) {
                    const formattedQuestions = data.map((q) => ({
                        id: q.id.toString(),
                        text: q.question,
                        options: [q.option1, q.option2, q.option3, q.option4].filter(opt => opt),
                        answer: q[q.correct] ?? q.correct,
                        solution: q.explanation,
                        subject: q.subject || 'General',
                        topic: q.tags || 'Unknown Topic',
                        difficulty: getDifficultyFromLevel(q.level),
                        type: q.type || 'Single Choice',
                    }));
                    setQuestions(formattedQuestions);
                }
            } catch (err) {
                console.error('Error fetching paper questions:', err);
                setError('Failed to load questions for this paper. Please try again later.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchQuestions();
    }, [selectedPaper]);
    
    const filteredQuestions = useMemo(() => {
        if (activeDifficulty === 'All' && activeSubject === 'All' && activeChapter === 'All') {
            return questions;
        }
        return questions.filter(q => 
            (activeDifficulty === 'All' || q.difficulty === activeDifficulty) &&
            (activeSubject === 'All' || q.subject === activeSubject) &&
            (activeChapter === 'All' || q.topic === activeChapter)
        );
    }, [questions, activeDifficulty, activeSubject, activeChapter]);

    const subjects = useMemo(() => ['All', ...new Set(questions.map(q => q.subject))], [questions]);
    const chapters = useMemo(() => {
        const filteredBySubject = activeSubject === 'All' 
            ? questions 
            : questions.filter(q => q.subject === activeSubject);
        return ['All', ...new Set(filteredBySubject.map(q => q.topic))];
    }, [questions, activeSubject]);

    useEffect(() => {
        setCurrentPage(1);
    }, [activeDifficulty, activeSubject, activeChapter]);

    useEffect(() => {
        if (activeSubject !== 'All') {
            setActiveChapter('All');
        }
    }, [activeSubject]);

    const totalPages = Math.ceil(filteredQuestions.length / PAGE_SIZE);
    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const questionsForCurrentPage = filteredQuestions.slice(startIndex, startIndex + PAGE_SIZE);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            document.querySelector('main')?.scrollTo(0, 0);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            document.querySelector('main')?.scrollTo(0, 0);
        }
    };

    const handlePaperSelect = (paperName: string) => {
        setSelectedPaper(paperName);
        setActiveDifficulty('All');
        setActiveSubject('All');
        setActiveChapter('All');
        setCurrentPage(1);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        if (selectedPaper && questions.length > 0) {
            setFilterData({
                subjects,
                chapters,
                activeSubject,
                activeChapter,
                activeDifficulty,
                onSubjectChange: setActiveSubject,
                onChapterChange: setActiveChapter,
                onDifficultyChange: setActiveDifficulty,
                questionCount: filteredQuestions.length,
                totalQuestions: questions.length
            });
            setShowFilter(true);
        } else {
            setShowFilter(false);
        }
    }, [selectedPaper, questions, subjects, chapters, activeSubject, activeChapter, activeDifficulty, filteredQuestions.length, setFilterData, setShowFilter]);
    


    const handleBackToPapers = () => {
        setSelectedPaper(null);
        setError(null);
        setQuestions([]);
        setActiveDifficulty('All');
        setActiveSubject('All');
        setActiveChapter('All');
        setCurrentPage(1);
        setShowFilter(false);
    };

    const handleAttemptPaper = (paper) => {
        setSelectedPaperForTest(paper);
        setShowTestConfig(true);
    };

    const handleStartTest = (test) => {
        if (!user) {
            sessionStorage.setItem('redirectPath', window.location.pathname);
            navigate('/signin');
            return;
        }
        
        sessionStorage.setItem('currentTest', JSON.stringify(test));
        navigate(`/test/${test.id}/instructions`, { 
            state: { test }
        });
    };


    if (selectedPaper) {


        return (
            <div className="animate-fade-in space-y-6">
                <header>
                    <button onClick={handleBackToPapers} className="flex items-center space-x-2 text-sm font-semibold text-brand-text-secondary hover:text-brand-primary transition-colors mb-4">
                        <ArrowLeftIcon className="w-5 h-5" />
                        <span>Back to Papers</span>
                    </button>
                    <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-brand-text-primary">{selectedPaper}</h1>
                    <p className="mt-2 text-lg text-brand-text-secondary">
                        Practice questions from this paper with advanced filtering options.
                    </p>
                </header>



                {isLoading && (
                    <div className="flex-1 flex items-center justify-center min-h-[calc(100vh-400px)]">
                        <div className="flex flex-col items-center">
                            <div className="w-12 h-12 border-4 border-brand-primary border-t-transparent rounded-full animate-spin"></div>
                            <p className="mt-4 text-brand-text-secondary">Fetching questions...</p>
                        </div>
                    </div>
                )}
                
                {error && (
                    <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border border-red-200">
                        <h3 className="text-lg font-semibold text-brand-accent-red">An Error Occurred</h3>
                        <p className="text-brand-text-secondary mt-1">{error}</p>
                    </div>
                )}
                
                {!isLoading && !error && (
                    filteredQuestions.length > 0 ? (
                        <div className="space-y-6">
                            {questionsForCurrentPage.map(q => {
                                const isBookmarked = !!user?.bookmarks?.questions?.[q.id];
                                return <QuestionCard key={q.id} question={q} user={user} isBookmarked={isBookmarked} onToggleBookmark={onToggleBookmark} onNavigateToSignIn={onNavigateToSignIn} />;
                            })}

                            {totalPages > 1 && (
                                <div className="flex items-center justify-between mt-8 pt-4 border-t border-brand-border">
                                    <button
                                        onClick={handlePrevPage}
                                        disabled={currentPage === 1}
                                        className="px-4 py-2 text-sm font-semibold rounded-lg border border-brand-border bg-brand-surface hover:bg-gray-100 dark:hover:bg-zinc-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Previous
                                    </button>
                                    <span className="text-sm font-semibold text-brand-text-secondary">
                                        Page {currentPage} of {totalPages}
                                    </span>
                                    <button
                                        onClick={handleNextPage}
                                        disabled={currentPage === totalPages}
                                        className="px-4 py-2 text-sm font-semibold rounded-lg border border-brand-border bg-brand-surface hover:bg-gray-100 dark:hover:bg-zinc-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border">
                            <h3 className="text-lg font-semibold text-brand-text-primary">No Questions Found</h3>
                            <p className="text-brand-text-secondary mt-1">
                                {questions.length > 0 
                                    ? `No questions match your current filters. Try adjusting your selection.`
                                    : `We couldn't find any questions for this paper yet. Please check back later.`
                                }
                            </p>
                        </div>
                    )
                )}
            </div>
        );
    }

    return (
        <div className="animate-fade-in space-y-6">
            <header>
                <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-brand-text-primary">JEE Main: Previous Year Papers</h1>
                <p className="mt-2 text-lg text-brand-text-secondary">
                    Select a paper to begin your practice session with advanced filtering.
                </p>
            </header>

            <div className="mt-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {papersData.map(paper => (
                        <PaperCard 
                            key={paper.shift} 
                            paper={paper} 
                            onClick={() => handlePaperSelect(paper.shift)}
                            onAttempt={() => handleAttemptPaper(paper)}
                        />
                    ))}
                </div>
            </div>
            
            {showTestConfig && (
                <TestConfigModal
                    paper={selectedPaperForTest}
                    onClose={() => setShowTestConfig(false)}
                    onStartTest={handleStartTest}
                    exam="JEE Main"
                    user={user}
                />
            )}
        </div>
    );
};
